<template>
  <div class="skeleton-card-outfit">
    <b-skeleton
      class="skeleton-card-outfit__image"
      :class="{ 'is-rtl': rtl }"
    />
    <div class="skeleton-card-outfit__content">
      <div class="d-flex items-center gap-5 mb-3">
        <div
          class="skeleton-card-outfit__content__title"
          style="height: 35px"
        />
        <div class="skeleton-card-outfit__content__title" style="width: 80px" />
      </div>
      <div class="skeleton-card-outfit__content__description" />
      <div class="skeleton-card-outfit__content__description" />
      <div class="skeleton-card-outfit__content__description" />
      <div class="skeleton-card-outfit__content__description" />
      <div class="skeleton-card-outfit__content__description" />
      <div
        class="skeleton-card-outfit__content__description mt-4 mb-2"
        style="height: 20px; max-width: 200px;"
      />
      <div
        class="skeleton-card-outfit__content__description"
        style="max-width: 300px;"
      />
      <div
        class="skeleton-card-outfit__content__description"
        style="max-width: 280px;"
      />
      <div
        class="skeleton-card-outfit__content__description"
        style="max-width: 310px;"
      />
      <b-skeleton class="skeleton-card-outfit__content__btn" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'SkeletonCardOutfit',
  props: {
    rtl: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
<style scoped>
.skeleton-card-outfit {
  display: flex;
  max-width: 70%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 5rem;
}

.skeleton-card-outfit__image {
  width: 45%;
  height: auto;
  margin: 0;
  display: flex;
  border-radius: 0;
  aspect-ratio: 41/49;
  background-color: #e5e5e5;
}

.is-rtl {
  order: 2;
}

.skeleton-card-outfit__content {
  display: flex;
  width: 55%;
  flex-direction: column;
  gap: 0.5rem;
  background-color: #f0f0f0;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 3rem;
}

.skeleton-card-outfit__content__title {
  width: 100%;
  height: 20px;
  background-color: #e5e5e5;
}

.skeleton-card-outfit__content__description {
  width: 100%;
  height: 16px;
  background-color: #e5e5e5;
}

.skeleton-card-outfit__content__btn {
  width: 152px;
  height: 50px;
  margin-left: auto;
  margin-top: 1rem;
  background-color: #e5e5e5;
}
@media (max-width: 768px) {
  .skeleton-card-outfit {
    flex-direction: column;
    margin-top: 2rem;
    margin-right: 0;
    margin-left: 0;
    max-width: none;
    background-color: #f0f0f0;
  }
  .skeleton-card-outfit__image {
    width: auto;
    margin: 1.5rem;
  }
  .skeleton-card-outfit__content {
    width: 100%;
    margin: 0;
  }
}
</style>
